import { useMemo } from 'react'
import { useCellVisualizationsSlice } from 'redux/slices/hooks/useCellVisualizationsSlice'
import { getColumn } from '../arrow/arqueroHelpers'

export const useCurrentCellCountAfterPrefilters = (): number => {
  const { dataFrame, prefilteredCellIdSet } = useCellVisualizationsSlice()

  return useMemo(() => {
    if (!dataFrame) return 0

    const cellIdColumn = getColumn<string>(dataFrame, 'CELL_ID')
    if (!cellIdColumn || cellIdColumn.length === 0) return 0

    let count = 0
    for (let i = 0; i < cellIdColumn.length; i += 1) {
      const cellId = cellIdColumn[i]
      if (cellId && !prefilteredCellIdSet.has(cellId)) {
        count += 1
      }
    }

    return count
  }, [dataFrame, prefilteredCellIdSet])
}

export default useCurrentCellCountAfterPrefilters
